import React, { useEffect, useState } from 'react'
import { listErrors } from '../../lib/admin-api'

export default function LogsPanel(){
  const [rows, setRows] = useState([])
  useEffect(()=>{ (async()=> setRows(await listErrors({limit:100})))() }, [])
  return (
    <Card title="Logs" subtitle="Last errors (PII masked)">
      <div className="overflow-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-background text-muted-foreground"><tr><th className="text-left p-2">When</th><th className="text-left p-2">Service</th><th className="text-left p-2">Severity</th><th className="text-left p-2">Message</th></tr></thead>
          <tbody className="divide-y divide-border">
            {rows.map(e=> (
              <tr key={e.id} className="hover:bg-muted/40">
                <td className="p-2">{new Date(e.at).toLocaleString()}</td>
                <td className="p-2">{e.service}</td>
                <td className="p-2">{e.severity}</td>
                <td className="p-2 text-muted-foreground">{maskPII(e.msg)}</td>
              </tr>
            ))}
            {rows.length===0 && <tr><td colSpan={4} className="p-4 text-muted-foreground">No errors</td></tr>}
          </tbody>
        </table>
      </div>
    </Card>
  )
}

function Card({ title, subtitle, actions, children }){
  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-1 p-6">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="text-lg font-semibold text-card-foreground">{title}</h3>
          {subtitle && <div className="text-sm text-muted-foreground">{subtitle}</div>}
        </div>
        {actions}
      </div>
      {children}
    </div>
  )
}
function maskPII(s){ return String(s||'').replace(/[\w.+-]+@[\w.-]+/g,'***@***') }

